module.exports = __webpack_public_path__ + "static/media/software-2.dea56dba.jpg";